<template>
  <div class="login forgot-pass vh-100 d-flex flex-column justify-content-center align-items-center bg-light">
    <div class="header p-3 position-absolute bg-white w-100 fixed-top">
      <h2 class="text-center">グローバルエステートサイト管理画面</h2>
    </div>
    <section class="wrapper">
      <div class="container-fluid">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img src="@/assets/img/client/logo.png" alt="" class="logo d-flex justify-content-center mb-5">
            <p class="text-left mb-3">メールアドレスを入力してもエラーになる場合は、ご入力のメールアドレスで登録されていない場合がございます。</p>
            <div class="w-100 bg-white p-4">
              <b-form class="m-auto">
              <div v-show="error" class="validation py-3 px-5 my-4">
                  <p class="m-0">{{ error }}</p>
              </div>
              <div v-show="status" class="validation py-3 px-5 my-4">
                  <p class="m-0">{{ status }}</p>
              </div>
                <div class="input-content">
                  <b-form-group>
                    <label for="" class="mb-3">メールアドレス</label>
                    <b-form-input
                    id="username"
                    type="text"
                    required
                    v-model="user.email_address"></b-form-input>
                  </b-form-group>
                </div>
                <div class="button-content text-center">
                  <router-link to="/administrator/login">
                    <b-button class="mx-3" variant="primary" size="lg">
                    戻る
                    </b-button>
                  </router-link>
                  <b-button variant="primary" size="lg" @click="handleClick(); forgetPassword()">
                    パスワード再登録URLを送信
                  </b-button>
                </div>
              </b-form>
            </div>
          </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ForgetPassword',
  data: function () {
    return {
      user: {
        email_address: null
      },
      status: null,
      error: null,
      loadingState: false
    }
  },
  computed: {
    ...mapState(['errors']),
    ...mapState('forgetPassword', ['processState'])
  },
  methods: {
    ...mapActions('forgetPassword', ['forget_password'], ['setErrors']),
    forgetPassword: function () {
      this.forget_password(this.user)
    },
    handleClick () {
      this.loadingState = true
    }
  },
  watch: {
    processState: function () {
      this.user.email_address = null
      this.error = ''
      this.status = '入力されたメールアドレスに、メールをお送りいたしました。メールに記載されているURLからアクセスしパスワードを再設定してください。'
      setTimeout(() => { this.status = null }, 5000)
    },
    errors: function () {
      this.error = 'メールアドレスを正しく入力してください'
      this.$store.dispatch('setErrors', null)
    }
  }
}
</script>
